/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://50uqf7nhjg.execute-api.eu-west-1.amazonaws.com/prod",
            "region": "eu-west-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://5jt4zeetorhbzhax67jty3vxbe.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-sfx4uv2pzng4vfznpihwbf7zi4",
    "aws_cognito_identity_pool_id": "eu-west-1:7652e2f0-2a2c-4c01-b492-e082c94dfc40",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_Qfh7xX6Ec",
    "aws_user_pools_web_client_id": "38pju7q709qpd2ru9l9cvmrm33",
    "oauth": {
        "domain": "stampyalphaf4a8255b-f4a8255b-prod.auth.eu-west-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/callback/,https://endtoend.dxtm5pityzcc8.amplifyapp.com/callback/,https://memento-card.it/callback/,https://www.memento-card.it/callback/",
        "redirectSignOut": "http://localhost:3000/callback/,https://endtoend.dxtm5pityzcc8.amplifyapp.com/callback/,https://memento-card.it/callback/,https://www.memento-card.it/callback/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "stampyalphaa5f953977844488b9bc48eca8588e0cf233546-prod",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
